import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import Navbar from "../Navbar";
import { Link } from "react-router-dom";
import CpfFeedProductionTable from "../Table/CpfFeedProductionTable";

const CpfFeedProduction = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="global-market-container">
        <div className="global-market-grid">
          <Link
            className="global-market-menuitem"
            to="/global-market/global-feed-production"
          >
            Global feed production
          </Link>
          <Link
            className="global-market-menuitem"
            to="/global-market/cp-world-wide"
          >
            CP World wide
          </Link>
          <Link
            className="global-market-menuitem"
            to="/global-market/cpf-feed-production"
          >
            CPF feed production
          </Link>
        </div>
        <iframe
          title="Production"
          width="100%"
          height="541.25"
          src="https://app.powerbi.com/reportEmbed?reportId=b64c56ca-1970-4627-bec5-15a91bacd043&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
        <div className="cpf-world-wide-title">
          ธุรกิจอาหารสัตว์เครือซีพี 15 ประเทศ ปี 2022
        </div>
        <CpfFeedProductionTable />
        {/* <tr>
          <td style={{ backgroundColor: "#003600" }}></td>
          <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>รวม</td>
          <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
            21,175
          </td>
          <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>
            17,088
          </td>
          <td style={{ backgroundColor: "#003600", color: "#b6d241" }}>81%</td>
          <td style={{ backgroundColor: "#112b43", color: "white" }}>11,056</td>
          <td style={{ backgroundColor: "#112b43", color: "white" }}>65%</td>
          <td style={{ backgroundColor: "#112b43", color: "white" }}>6,032</td>
          <td style={{ backgroundColor: "#112b43", color: "white" }}>35%</td>
        </tr> */}
      </div>
    </div>
  );
};

export default CpfFeedProduction;
